/// <reference path="../_references.ts"/>

module App.NgSortable {

    import Package = App.PriceGuide.Package;
    export type ItemPosition = {
        dirX: number;
        dirY: number;
        distAxX: number;
        distAxY: number;
        distX: number;
        distY: number;
        lastDirX: number;
        lastDirY: number;
        lastX: number;
        lastY: number;
        nowX: number;
        nowY: number;
        offsetX: number;
        offsetY: number;
        startX: number;
        startY: number;
    }

    export type OrderChangedEvent = {
        dest: Destination;
        source: Source;
    }

    export type Destination = {
        index: number;
        sortableScope: ng.IScope;
    }

    export type Source = {
        index: number;
        itemScope: ItemScope;
        sortableScope: ng.IScope;
    }

    export interface ItemScope extends ng.IScope {
        package: Package;
    }
}
